import {BriefPanelName, PanelTypeEnum, Unit, VAxisType} from '@balrog/component/common';
import {ProfileInterface} from './interface/profile.interface';

export class MinisterJFCProfile implements ProfileInterface {
    statuses = {
        MINISTER_JFC_STAT_OUT_STATE_D1: {title: 'Dmuchawa D1'},
        MINISTER_JFC_STAT_OUT_STATE_P1: {title: 'Pompa P1'},
        MINISTER_JFC_STAT_OUT_STATE_Z1: {title: 'Zawór Z1'},
        MINISTER_JFC_STAT_OUT_STATE_Z2: {title: 'Zawór Z2'},
        MINISTER_JFC_STAT_OUT_STATE_ALARM: {title: 'Wyjście alarmowe'},
    };
    // alarmy
    alarms = {
        MINISTER_JFC_ALARM_PROGRAM_MEMORY_ERROR: {title: 'Błąd pamięci nastaw'},
        MINISTER_JFC_ALARM_SETTINGS_MEMORY_ERROR: {title: 'Błąd pamięci programu'},
        MINISTER_JFC_ALARM_RTC_ERROR: {title: 'Awaria zegara RTC'},
        MINISTER_JFC_ALARM_WRONG_CURRENT_D1: {title: 'Błąd pomiaru prądu D1'},
        MINISTER_JFC_ALARM_WRONG_CURRENT_P1: {title: 'Błąd pomiaru prądu P1'},
    };

    briefPanel = {
        name: BriefPanelName.ELEKTROMIZ_MINISTER_JFC
    };

    dashBoard = {
        panelType: PanelTypeEnum.ELEKTROMIZ_MINISTER_JFC
    };

    historyBoard = {
        content: [
            {
                paramId: 'MINISTER_JFC_VAL_CURRENT_D1',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
            },
            {
                paramId: 'MINISTER_JFC_VAL_CURRENT_Z1',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
            },
            {
                paramId: 'MINISTER_JFC_VAL_CURRENT_Z2',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
            },
            {
                paramId: 'MINISTER_JFC_VAL_CURRENT_P1',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
            },
        ]
    };

    listBoard = {
        title: 'Konfiguracja',
        content: [
        {
            paramId: 'MINISTER_JFC_VAL_SOFT_VER',
            unit: Unit.NONE,
            step: 0.01,
        },
        {
            title: 'Odczyty',
            type: 'MENU',
            content: [
                {
                    paramId: 'MINISTER_JFC_VAL_CURRENT_D1',
                    unit: Unit.A,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_CURRENT_Z1',
                    unit: Unit.A,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_CURRENT_Z2',
                    unit: Unit.A,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_CURRENT_P1',
                    unit: Unit.A,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_CONTROLLER_STATE',
                    options: [
                        {value: '0', name: 'Oczekiwanie'},
                        {value: '1', name: 'Faza I'},
                        {value: '2', name: 'Faza II'},
                        {value: '3', name: 'Faza III'},
                        {value: '4', name: 'Faza IV'},
                        {value: '5', name: 'Faza V'},
                    ]
                },
                {
                    paramId: 'MINISTER_JFC_VAL_CONTROLLER_PHASE_2_STATE',
                    options: [
                        {value: '0', name: 'Praca'},
                        {value: '1', name: 'Pauza'},
                    ]
                },
            ]
        },
        {
            title: 'Dane historyczne',
            type: 'MENU',
            content: [
                {
                    paramId: 'MINISTER_JFC_VAL_TOTAL_TURN_ON_TIME_D1',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_TOTAL_TURN_ON_TIME_Z1',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_TOTAL_TURN_ON_TIME_Z2',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_TOTAL_TURN_ON_TIME_P1',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'MINISTER_JFC_VAL_TOTAL_TURN_ON_TIME_ALARM',
                    unit: Unit.SEC,
                },
            ]
        },
            {
                title: 'Nastawy',
                type: 'MENU',
                content: [
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_1_ON_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_2_ON_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_2_OFF_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_2_CYCLES',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_3_ON_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_4_ON_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_PHASE_5_ON_TIME',
                    unit: Unit.SEC,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_MIN_D1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_MAX_D1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_MIN_P1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_MAX_P1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_FIRST_CYCLE_START_TIME_H',
                    unit: Unit.HOUR,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_FIRST_CYCLE_START_TIME_M',
                    unit: Unit.MIN,
                    step: 1,
                },
                {
                    paramId: 'MINISTER_JFC_SETP_FIRST_CYCLE_START_TIME_S',
                    unit: Unit.SEC,
                    step: 1,
                },
            ]
        }
    ]};
    scheduleBoard = null;
}
